import { YupArraySchema, yup } from '@framework/validation';
import {
  IComputeExpressionValueReference,
  IComputeExpressionValueText,
} from '../../../../expressions/compute/ComputeExpression';
import { ComputeExpressionSchema } from '../../../../expressions/compute/validation/ComputeExpressionSchema';
import { WidgetType } from '../../../Widget';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent';
import { IComputedStringWidget } from '../IComputedWidget';

const ComputedStringExpressionSchema = yup
  .object({
    value: ComputeExpressionSchema.fields.value as YupArraySchema<
      IComputeExpressionValueReference | IComputeExpressionValueText
    >,
    raw: yup.string().label('Espressione').default('').required(),
  })
  .required()
  .noUnknown()
  .label('Espressione');

export const ComputedStringConfigSchema: yup.ObjectSchema<IComputedStringWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup
      .string()
      .required()
      .exact(WidgetType.ComputedString)
      .label('Tipo'),
    expression: ComputedStringExpressionSchema,

    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
      removeBorder: yup
        .boolean()
        .required()
        .default(false)
        .label('Rimuovi bordo'),
    }),
  })
    .required()
    .noUnknown();
